import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconEyeHideSvg } from './IconEyeHideSvg';

export const IconEyeHide: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconEyeHideSvg} {...iconProps} />;
};
